import { render, staticRenderFns } from "./EditVideoTool.vue?vue&type=template&id=a5c07520&scoped=true&"
import script from "./EditVideoTool.vue?vue&type=script&lang=js&"
export * from "./EditVideoTool.vue?vue&type=script&lang=js&"
import style0 from "./EditVideoTool.vue?vue&type=style&index=0&id=a5c07520&scoped=true&lang=scss&"
import style1 from "./EditVideoTool.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c07520",
  null
  
)

export default component.exports